import type { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import { useBoardSwitcherWorkspaceFragment } from './BoardSwitcherWorkspaceFragment.generated';

export const WorkspaceDisplayName: FunctionComponent<{
  workspaceId: string;
}> = ({ workspaceId }) => {
  const { data } = useBoardSwitcherWorkspaceFragment({
    from: { id: workspaceId },
    returnPartialData: true,
  });

  if (data?.displayName) {
    return data.displayName;
  }

  if (data?.name) {
    return data.name;
  }

  return (
    <FormattedMessage
      id="templates.board_switcher.unknown-workspace"
      defaultMessage="Unknown workspace"
      description="Title of an unknown workspace on the board switcher"
    />
  );
};
